function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg251Mongolia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.007,
    style: {
      fill: "#0052B4"
    },
    width: 511.989,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.001,
    style: {
      fill: "#A2001D"
    },
    width: 170.663,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.336,
    style: {
      fill: "#A2001D"
    },
    width: 170.663,
    height: 512
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 119.017,
    y: 270.058,
    style: {
      fill: "#FFDA44"
    },
    width: 18.746,
    height: 74.986
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.031,
    y: 270.058,
    style: {
      fill: "#FFDA44"
    },
    width: 18.746,
    height: 74.986
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDA44"
    },
    cx: 90.901,
    cy: 298.173,
    r: 18.746
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDA44"
    },
    cx: 90.901,
    cy: 232.57,
    r: 9.373
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.15,
    y: 326.3,
    style: {
      fill: "#FFDA44"
    },
    width: 37.492,
    height: 18.746
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.15,
    y: 251.314,
    style: {
      fill: "#FFDA44"
    },
    width: 37.492,
    height: 18.746
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "90.896,166.957 97.535,187.385 119.014,187.385 101.638,200.013 108.272,220.442    90.896,207.815 73.519,220.442 80.154,200.013 62.777,187.385 84.256,187.385  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg251Mongolia);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3QgeD0iMC4wMDciIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiB3aWR0aD0iNTExLjk4OSIgaGVpZ2h0PSI1MTIiLz4KPGc+Cgk8cmVjdCB4PSIwLjAwMSIgc3R5bGU9ImZpbGw6I0EyMDAxRDsiIHdpZHRoPSIxNzAuNjYzIiBoZWlnaHQ9IjUxMiIvPgoJPHJlY3QgeD0iMzQxLjMzNiIgc3R5bGU9ImZpbGw6I0EyMDAxRDsiIHdpZHRoPSIxNzAuNjYzIiBoZWlnaHQ9IjUxMiIvPgo8L2c+CjxnPgoJPHJlY3QgeD0iMTE5LjAxNyIgeT0iMjcwLjA1OCIgc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHdpZHRoPSIxOC43NDYiIGhlaWdodD0iNzQuOTg2Ii8+Cgk8cmVjdCB4PSI0NC4wMzEiIHk9IjI3MC4wNTgiIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiB3aWR0aD0iMTguNzQ2IiBoZWlnaHQ9Ijc0Ljk4NiIvPgoJPGNpcmNsZSBzdHlsZT0iZmlsbDojRkZEQTQ0OyIgY3g9IjkwLjkwMSIgY3k9IjI5OC4xNzMiIHI9IjE4Ljc0NiIvPgoJPGNpcmNsZSBzdHlsZT0iZmlsbDojRkZEQTQ0OyIgY3g9IjkwLjkwMSIgY3k9IjIzMi41NyIgcj0iOS4zNzMiLz4KCTxyZWN0IHg9IjcyLjE1IiB5PSIzMjYuMyIgc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHdpZHRoPSIzNy40OTIiIGhlaWdodD0iMTguNzQ2Ii8+Cgk8cmVjdCB4PSI3Mi4xNSIgeT0iMjUxLjMxNCIgc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHdpZHRoPSIzNy40OTIiIGhlaWdodD0iMTguNzQ2Ii8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojRkZEQTQ0OyIgcG9pbnRzPSI5MC44OTYsMTY2Ljk1NyA5Ny41MzUsMTg3LjM4NSAxMTkuMDE0LDE4Ny4zODUgMTAxLjYzOCwyMDAuMDEzIDEwOC4yNzIsMjIwLjQ0MiAgICA5MC44OTYsMjA3LjgxNSA3My41MTksMjIwLjQ0MiA4MC4xNTQsMjAwLjAxMyA2Mi43NzcsMTg3LjM4NSA4NC4yNTYsMTg3LjM4NSAgIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };